<template>

  <PageShell class="page-shell-wrapper--home" locale="id" hide-title>
    <HomeContent locale="id" />

  </PageShell>

</template>



<script>

import PageShell from '@/components/layout/PageShell.vue';

import HomeContent from './HomeContent.vue';



export default {

  name: 'HomeId',

  components: { PageShell, HomeContent },

};

</script>


